import { generateSelectorReference } from '@/employees/components/Selector/utilities/generateReference'
import { deleteDisplaySelector, isCompositeType, isNotType, setDisplaySelector } from '@/employees/components/Selector/utilities/builder/selectorBuilder'
import { SELECTOR_TYPE } from '@/constants'
import _cloneDeep from 'lodash/cloneDeep'
// #region Add selector reference
export function addSelectorReferences (selector) {
  const selectorClone = _cloneDeep(selector)
  addSelectorReference(selectorClone)
  return selectorClone
}
function addSelectorReference (selector) {
  const reference = generateSelectorReference()
  selector.reference = reference
  addOperator(selector)
  setDisplaySelectorForAddReference(selector.type, reference)
  if (isCompositeType(selector)) {
    for (let i = 0; i < selector.selectors.length; i++) {
      addSelectorReference(selector.selectors[i])
    }
  } else if (isNotType(selector)) {
    addSelectorReference(selector.selector)
  }
}
function setDisplaySelectorForAddReference (type, reference) {
  switch (type) {
    case SELECTOR_TYPE.composite:
      setDisplaySelector(reference)
      break
    case SELECTOR_TYPE.not:
      setDisplaySelector(reference)
      break
  }
}
function addOperator (selector) {
  if (isCompositeType(selector) && !selector.operator) {
    selector.operator = 'and'
  }
}
// #endregion
// #region Delete selector reference
export function deleteSelectorReferences (selector) {
  const selectorClone = _cloneDeep(selector)
  deleteSelectorReference(selectorClone)
  return selectorClone
}
function deleteSelectorReference (selector) {
  deleteDisplaySelectorForAddReference(selector.type, selector.reference)
  delete selector.reference
  if (isCompositeType(selector)) {
    for (let i = 0; i < selector.selectors.length; i++) {
      deleteSelectorReference(selector.selectors[i])
    }
  } else if (isNotType(selector)) {
    deleteSelectorReference(selector.selector)
  }
}
function deleteDisplaySelectorForAddReference (type, reference) {
  switch (type) {
    case SELECTOR_TYPE.composite:
      deleteDisplaySelector(reference)
      break
    case SELECTOR_TYPE.not:
      deleteDisplaySelector(reference)
      break
  }
}
// #endregion
